import { CartUpdatedEvent } from '@theme/events';

const QUICK_ADD_SELECTOR = '[data-add-variant]';
const OPEN_MODAL_SELECTOR = '[data-open-quick-add]';
const CLOSE_MODAL_SELECTOR = '[data-close-quick-add]';

function getCartDrawerSectionId() {
  return document.querySelector('cart-drawer')?.dataset.sectionId || null;
}

function showQuickAddToast(message, isError = false) {
  let toast = document.querySelector('.byrunx-quick-add-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'byrunx-quick-add-toast';
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.toggle('error', isError);
  toast.classList.add('is-visible');

  window.clearTimeout(toast.dataset.timeoutId);
  toast.dataset.timeoutId = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 2200);
}

function getQuickAddModal(productId) {
  return document.querySelector(`[data-quick-add-modal="${CSS.escape(productId)}"]`);
}

function openQuickAddModal(productId) {
  const modal = getQuickAddModal(productId);
  if (!modal) return;

  modal.classList.add('is-open');
  document.body.classList.add('byrunx-quick-add-lock');
}

function closeQuickAddModal(productId) {
  const modal = getQuickAddModal(productId);
  if (!modal) return;

  modal.classList.remove('is-open');
  document.body.classList.remove('byrunx-quick-add-lock');
}

async function addVariantToCart(button) {
  const variantId = button.dataset.addVariant;
  if (!variantId || button.disabled || button.classList.contains('is-loading')) return;

  button.classList.add('is-loading');
  button.disabled = true;

  const sections = [];
  const cartDrawerSectionId = getCartDrawerSectionId();
  if (cartDrawerSectionId) sections.push(cartDrawerSectionId);

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.description || data?.message || 'Ajout panier impossible');
    }

    const currentItemCount = document.querySelector('cart-icon')?.getCurrentItemCount?.();
    const itemCount = currentItemCount != null ? currentItemCount + 1 : data.item_count || 1;

    document.dispatchEvent(
      new CartUpdatedEvent(
        {},
        {
          itemCount,
          source: 'product-card-media-quick-add',
          sections: data.sections || {},
          variantId,
        },
      ),
    );

    const closeModalProductId = button.dataset.closeModalAfterAdd;
    if (closeModalProductId) closeQuickAddModal(closeModalProductId);

    showQuickAddToast(Theme.translations.addToCartNotificationMessage || 'Produit ajouté au panier');
  } catch (error) {
    console.error('[GLIIMA quick add] error', error);
    showQuickAddToast(error.message || 'Ajout panier impossible', true);
  } finally {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const sizeButton = target.closest(QUICK_ADD_SELECTOR);
  if (sizeButton) {
    event.preventDefault();
    event.stopPropagation();
    addVariantToCart(sizeButton);
    return;
  }

  const openButton = target.closest(OPEN_MODAL_SELECTOR);
  if (openButton) {
    event.preventDefault();
    event.stopPropagation();
    openQuickAddModal(openButton.dataset.openQuickAdd);
    return;
  }

  const closeButton = target.closest(CLOSE_MODAL_SELECTOR);
  if (closeButton) {
    event.preventDefault();
    event.stopPropagation();
    closeQuickAddModal(closeButton.dataset.closeQuickAdd);
  }
});
